/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BuccalCenter/view.blocks to change it.
import React from 'react'
import sourceJpg from "./source.jpg"
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BuccalCenter({
  children,
  viewPath = "/DesignSystem/Images/BuccalCenter",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 317,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourceJpg,
  width = 678
  
}) {
  return (<React.Fragment
>
<img
  data-testid="BuccalCenter.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z3WJtW': alignSelf,'--bc-2-Z3WJtW': backgroundColor,'--bblr-3-Z3WJtW': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z3WJtW': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z3WJtW': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z3WJtW': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z3WJtW': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z3WJtW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z3WJtW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z3WJtW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z3WJtW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z3WJtW': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}